import styled from 'styled-components';

import { inputStyles, Wrapper } from '../input/index.styles';

export { Wrapper };

export const Textarea = styled.textarea`
  ${inputStyles};
  line-height: 1.2;
`;
